import styled from 'styled-components';
import Alert from '@lendi-ui/alert';
import getColour from '@lendi-ui/commons/colours';
import { mb, ml, mr, mt, p, pb, pt } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';
import { Body, body } from '@lendi-ui/typography';

import { TempCardHeader } from '../../Card/index.style';
import Stack from '../../Stack';

export const ABNCardHeaderText = styled.div`
  ${body({ size: 'xs' })}
  color: ${() => getColour('text', 'main')};
`;

export const ABNCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom-left-radius: ${select('borderRadius')};
  border-bottom-right-radius: ${select('borderRadius')};
  position: relative;
`;

export const ABNCardHeader = styled(TempCardHeader)`
  background-color: ${() => getColour('background', 'container')};
`;

export const ABNTableContents = styled.div`
  > * :last-child {
    ${mb('nil')}
    border-bottom: none;
  }
`;

export const ABNTableItemWrapper = styled.div`
  ${pb('sm')}
  ${pt('sm')}
  border-bottom: solid 1px;
  border-color: ${() => getColour('border', 'container')};
  &:hover {
    background-color: ${() => getColour('shade', 50)};
  }
`;

export const TableItemBorder = styled.div`
  ${ml('xs')}
  ${mr('xs')}
`;

export const ABNTableItemUpper = styled(Stack)`
  justify-content: space-between;
`;

export const PagerContainer = styled(Stack)`
  & :nth-child(n + 2):not(:last-child) {
    ${p('xs')}
  }
`;

export const LeftAlignedDetail = styled(Body)`
  text-align: left;
`;

export const ABNError = styled(Alert)`
  ${mt('xs')}
`;

export const InputWrapper = styled.div``;
